import UserResetPasswordComponent from "../../components/UserResetPasswordComponent";

export default UserResetPasswordComponent;